
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabRTRootProps = TemplateRootPropsForTag<'a'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabRT(): TemplateResult<fitmentTableTabRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('a', {
        'className': 'tab-title',
        'href': '#tab-fitment',
        'tabIndex': '0',
        'key': '0'
    }, '\n  Fitment\n') : null;
}
        export const componentNames = []